import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import * as logger from "../../../logger";
import { deleteShop } from '../../../store/actions/vehicleActionCreator';
import { connect } from "react-redux";
import { sendSucces } from '../../../utils/utils';
const useStyles = makeStyles((theme) => ({
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    divV1: {
        fontWeight: 300, fontSize: 16
    },
    titleV1:{
        fontWeight: 600
    }
}));

const DeleteShopDialog = ({ open, shopId, onConfirm, onClose, dispatchShopDelete }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }


    const onDelete = () => {
        dispatchShopDelete(shopId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    sendSucces("Delete Shop Successful")
                    logger.log("Delete Shop Dialog Dweb", "Delete Shop Successfull");
                    setDialogOpen(false);
                    onConfirm();
                }else{
                    handleDialogClose()
                }
            },
            () => {
                handleDialogClose()
                logger.log("Delete Shop Dialog Dweb", "Delete Shop Failed");
            }
        )
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                 <DialogTitle >
                    <div className={classes.divAlign}>
                        <div className={classes.titleV1}>{"Delete Shop"}</div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className={classes.divV1}>Do you want to delete the Shop ? </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            NO
                        </span>
                    </Button>
                    <Button onClick={onDelete}>
                        <span className={classes.deleteV1}>
                            YES
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    dispatchShopDelete: (id, onSuccess, onFailure) => dispatch(deleteShop(id, onSuccess, onFailure))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteShopDialog);
